<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc01">
</a><a id="page_v">
<h2 class="chaptertitle">Contents</h2>
</a><p class="toc"><a id="page_v"></a><a href="#/list_of_illustrations">List of Illustrations</a></p>
<p class="toc"><a href="#/ack">Acknowledgments</a></p>
<p class="toc"><a href="#/foreword">Foreword by Erin Sullivan</a></p>
<p class="toc1"><a href="#/part01"><b>Part One: Setting the Scene</b></a></p>
<p class="toc"><a href="#/part01#c1"><i>Introduction:</i> The Philosophical Foundation of the Counseling Practice</a></p>
<p class="toc"><a href="#/chap01">1 Making Contact—Creating the Unified Field with Your Client</a></p>
<p class="toc"><span href="#/chap02" title="Link target outside of Sample">2 Communication—Getting to Your Client's Core Issues</span></p>
<p class="toc"><span href="#/chap03" title="Link target outside of Sample">3 Evoking Inner Resources—Empowering Your Client</span></p>
<p class="toc1"><span href="#/part02" title="Link target outside of Sample"><b>Part Two: The Major Players—Planetary Combinations</b></span></p>
<p class="toc"><span href="#/part02#c1" title="Link target outside of Sample"><i>Introduction:</i> The Inner and Outer Planets</span></p>
<p class="toc"><span href="#/chap04" title="Link target outside of Sample">4 The Sun—Existential Challenges</span></p>
<p class="toc"><span href="#/chap05" title="Link target outside of Sample">5 The Moon—Cradle of the Unconscious</span></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample">6 Mercury—Making Connections</span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample">7 Venus—Bonding</span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample">8 Mars—Warrior and Lover</span></p>
<p class="toc"><span href="#/chap09" title="Link target outside of Sample">9 Jupiter through Pluto—the Collective Framework</span></p>
<a id="page_vi">
</a><p class="toc1"><a id="page_vi"></a><span href="#/part03" title="Link target outside of Sample"><b>Part Three: Transformation Methods</b></span></p>
<p class="toc"><span href="#/part03#c1" title="Link target outside of Sample"><i>Introduction:</i> Astrology That Works</span></p>
<p class="toc"><span href="#/chap10" title="Link target outside of Sample">10 First Impressions—Winning the Client's Confidence</span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample">11 Awareness of the Problem—and Seeing It in a New Way</span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample">12 Reframing—an Empowering Intervention</span></p>
<p class="toc"><span href="#/chap13" title="Link target outside of Sample">13 Memory—Helping Clients Recall Core Material</span></p>
<p class="toc"><span href="#/chap14" title="Link target outside of Sample">14 Past, Present, Future—Changing with the Time Continuum</span></p>
<p class="toc"><span href="#/chap15" title="Link target outside of Sample">15 Deeper Intervention Techniques</span></p>
<p class="toc"><span href="#/chap16" title="Link target outside of Sample">16 Other Intervention Techniques—Secret Therapy, Metaphor, and Direct Feedback</span></p>
<p class="toc"><span href="#/chap17" title="Link target outside of Sample">17 Synastry Consultations</span></p>
<p class="toc"><span href="#/chap18" title="Link target outside of Sample">18 Points to Remember</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample"><b>Appendix: Meditation on the Four Elements</b></span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?74d0603e